export function formatCurrency(amount: number, locale: string = "en-US", currency: string = "USD"): string {
  return amount.toLocaleString(locale, {
    style: "currency",
    currency: currency,
  });
}

export const US_DOLLAR_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const US_DOLLAR_FORMATTER_NO_DECIMALS = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
